export enum ELayoutManagerMode {
  VIEW = 'view', // Settings preview for non-editable templates - read-only display
  EDIT = 'edit', // Settings preview for custom templates - FULL DnD + tap logic
  RENDER = 'render', // Production use in MainMapPage - NO DnD, NO tap logic, pure rendering
}
